import { rootReducerInitializer } from '@mtblc/mtblc-redux';
import { connectRouter } from 'connected-react-router';
import entities from './entities';
import branch from './branch';
import profile from './profile';

// Use for clearing the store on certain actions (like LOGOUT)
const resetActionTypes = [];

export default history => rootReducerInitializer({
  entities,
  branch,
  profile,
  router: connectRouter(history),
}, resetActionTypes);
